<p-toolbar styleClass="mt-2 mb-2">
  <div class="p-toolbar-group-start"></div>
  <div class="p-toolbar-group-end" *ngIf="component !== 'services'">
    <div class="formgroup-inline searchbox-button">
      <p-button icon="pi pi-plus" class="" label="{{ 'ADD_ROW' | translate }}" (onClick)="addRow()" [disabled]="disallowEdit" />
    </div>
  </div>
</p-toolbar>

<div id="spreadsheet" class="spreadsheet" #vsSheet></div>
<p-dialog
  header="Editor"
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '50vw', height: '70vh' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onShow)="onShow($event)"
  (onResizeEnd)="onResizeEnd($event)"
>
  <ngx-monaco-editor [options]="editorOptions" class="json-editor" [(ngModel)]="codeEditor" style="height: 100%">
  </ngx-monaco-editor>
  <ng-template #footer>
    <div class="text-right btn-wrapper" *ngIf="!disallowEdit">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="submitCode()" [disabled]="this.readOnly">
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
